import React, { Component } from "react";
import Functions from "./functions";
import Modules from "../modules/modules";
import Themes from "../themes/themes";
import SimpleReactValidator from "simple-react-validator";

class Manager extends Component {
	constructor(props) {
		super(props);

		this.validator = new SimpleReactValidator();
		this.createUI = this.createUI.bind(this);
		this.restCallback = this.restCallback.bind(this);
		this.refresh = this.refresh.bind(this);
		this.loadModule = this.loadModule.bind(this);

		this.templateRef = React.createRef();

		let moduleName = this.props.module;
		let view = this.props.view;
		let customParameters = this.props.customParameters
			? this.props.customParameters
			: { replace: {}, headers: {} };
		let inputData = this.props.inputData;
		let parentData = this.props.parentData;

		this.state = {
			moduleName: moduleName,
			loaded: false,
			view: view,
			customParameters: customParameters,
			parentData: parentData,
			inputData: inputData,
			theme: window["fw_theme"](),
			postData: null,
		};
	}

	componentDidMount() {
		let module = Functions.clone(
			Modules[this.state.moduleName]["views"][this.state.view],
		);

		this.setState({
			module: module,
			template: module["template"],
			loaded: false,
		});

		this.loadModule(module);
	}

	refresh() {
		let module = Functions.clone(
			Modules[this.state.moduleName]["views"][this.state.view],
		);

		this.setState({
			module: module,
			template: module["template"],
			// loaded: false,
		});

		this.loadModule(module);
	}

	checkAuthorization(module) {
		if (module.auth) {
			if (typeof module.auth === "function") {
				return module.auth();
			}
		}
		return true;
	}

	loadModule(module) {
		if (this.checkAuthorization(module)) {
			Functions.REST({
				api: module.apis.view,
				customParameters: this.state.customParameters,
				method: module.apis.view.method ? module.apis.view.method : "GET",
				component: this,
				module: module,
				postData: module.apis.view.postData ? module.apis.view.postData : null,
				parentData: this.state.parentData,
				inputData: this.state.inputData ? this.state.inputData : null,
				callback: this.restCallback,
			});
		}
	}

	restCallback(data, status, response) {
		if (this.state.module) {
			let enrichedData = Functions.enrichData({
				module: this.state.module,
				data: data,
				manager: this,
			});

			this.setState({
				data: enrichedData,
				loaded: true,
				restData: response.data,
			});
		}
	}

	createUI() {
		let Template = Themes[this.state.theme][this.state.template];

		if (this.checkAuthorization(this.state.module)) {
			return (
				<Template
					data={this.state.data}
					restData={this.state.restData}
					manager={this}
					module={this.state.module}
					ref={this.templateRef}
					key={Functions.key()}></Template>
			);
		}
		return "";
	}

	render() {
		if (this.state.loaded) {
			return this.createUI();
		}

		return "";
	}
}

export default Manager;
